import { z } from 'zod';

// Credit Application Form Schema
export const creditApplicationFormSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First name is required')
    .max(100, 'First name must not exceed 100 characters'),
  surname: z
    .string()
    .min(1, 'Surname is required')
    .max(100, 'Surname must not exceed 100 characters'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^(?:[+]?\d+(?:\s*\d+)*(?:-\d+)?)?$/, 'Invalid phone number'),
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
  accountNo: z.string().optional(),
  company: z.string().min(1, 'Company is required'),
  establishmentType: z.string().min(1, 'Establishment type is required'),
  establishmentName: z
    .string()
    .min(1, 'Establishment name is required')
    .max(250, 'Establishment name must not exceed 250 characters'),
  city: z
    .string()
    .min(1, 'Town is required')
    .max(250, 'Town must not exceed 250 characters'),
  postcode: z
    .string()
    .min(1, 'Postcode is required')
    .max(250, 'Postcode must not exceed 250 characters'),
});

export type CreditApplicationFormSchema = z.infer<
  typeof creditApplicationFormSchema
>;
